import * as React from "react"
import { TextFieldSeeker } from "@ui-seeker/core"

import { useAdminBrandForm } from "../../@hooks"


export default function AdminBrandsNameTextField({ disabled }) {
	const { value, handleChange } = useAdminBrandForm('brandName')

    return <TextFieldSeeker
		label="Brand"
		placeholder="Please enter a brand name..."
		value={value}
		disabled={disabled}
		onChange={e => handleChange(e.target.value)}
	/>	
}